(() => {
  const warmed = new Set();

  function preloadVariantImages() {
    document.querySelectorAll('[data-variant-image-src]').forEach((option) => {
      const src = option.dataset.variantImageSrc;
      if (!src || warmed.has(src)) return;
      warmed.add(src);
      const image = new Image();
      image.srcset = option.dataset.variantImageSrcset || '';
      image.sizes = '(max-width: 749px) 100vw, 50vw';
      image.src = src;
    });
  }

  function showVariantImage(option) {
    const picker = option.closest('variant-selects, variant-radios');
    if (!picker || !option.dataset.variantImageSrc) return;

    const product = picker.closest('.product');
    const quickAdd = picker.closest('quick-add-modal');
    const gallery = product?.querySelector('media-gallery');

    if (!quickAdd && gallery?.setActiveMedia && option.dataset.variantMediaId) {
      gallery.setActiveMedia(option.dataset.variantMediaId, true);
    }

    if (quickAdd) {
      const image = product?.querySelector('.product__media-item:first-child img');
      if (!image) return;
      image.srcset = option.dataset.variantImageSrcset || '';
      image.src = option.dataset.variantImageSrc;
      image.alt = option.dataset.variantImageAlt || image.alt;
    }
  }

  document.addEventListener('change', (event) => {
    const option = event.target.closest?.('[data-variant-image-src]');
    if (option) showVariantImage(option);
  }, true);

  const warm = () => preloadVariantImages();
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(warm, { timeout: 1800 });
  } else {
    window.setTimeout(warm, 500);
  }

  document.addEventListener('shopify:section:load', warm);
})();
